"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Game = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#000' : _b, _c = _a.scale, scale = _c === void 0 ? 1 : _c, _d = _a.strokeWidth, strokeWidth = _d === void 0 ? 1 : _d;
    return (react_1.default.createElement("svg", { width: scale * 24, height: scale * 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M10 12L8 19H16L14 12H10Z", stroke: color, strokeWidth: strokeWidth }),
        react_1.default.createElement("rect", { x: "8", y: "9", width: "8", height: "3", rx: "1.5", stroke: color, strokeWidth: strokeWidth }),
        react_1.default.createElement("rect", { x: "5", y: "19", width: "14", height: "4", rx: "1", stroke: color, strokeWidth: strokeWidth }),
        react_1.default.createElement("circle", { cx: "12", cy: "5", r: "4", stroke: color, strokeWidth: strokeWidth })));
};
exports.default = Game;
//# sourceMappingURL=Game.js.map